// extracted by mini-css-extract-plugin
export default {"hoverKim":"index__hoverKim___xwOGq","kimImg":"index__kimImg___ZG6wF","username":"index__username___JXOls"};